import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { SectionsIcon } from '@novafuturltd/shared'

interface MenuSectionsProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuSections = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuSectionsProps) => {
  const { formatMessage } = useIntl()

  const isDefaultPath = pathname.startsWith('/casino/sections')

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href={`/casino/sections`}
        selected={isDefaultPath}
      >
        <ListItemIcon>
          <SectionsIcon />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'casino.submenu.sections.title',
          })}
        />
      </MenuItem>
    </div>
  )
}
